import React from 'react';
import { Badge } from '@chakra-ui/react';
import { useCrmSettings } from '../../contexts/CrmSettingsContext';

export default function StageBadge({ stage }) {
  const { getDealStage } = useCrmSettings();

  if (!stage) return null;

  const stageConfig = getDealStage(stage);
  const colorScheme = stageConfig?.color || 'gray';
  const label = stageConfig?.label || stage;

  return (
    <Badge colorScheme={colorScheme} fontSize="xs" textTransform="uppercase">
      {label}
    </Badge>
  );
}

